import React from 'react';

export const LIVE_PREVIEWS_UPSELL_STORAGE_KEY =
  'postdrop.sendTest.livePreviewsUpsell:v1';

const previews1xSrc = '/img/previews-1x.webp';
const previews2xSrc = '/img/previews-2x.webp';
const previews3xSrc = '/img/previews-3x.webp';

type LivePreviewsUpsellProps = {
  onTryNow: () => void;
  onDismiss?: () => void;
  dismissible?: boolean;
  className?: string;
};

/**
 * Shared Live Previews promo used in the send-test modal.
 * Caller decides free-plan gating; dismiss persistence uses LIVE_PREVIEWS_UPSELL_STORAGE_KEY.
 */
export function LivePreviewsUpsell({
  onTryNow,
  onDismiss,
  dismissible = true,
  className = '',
}: LivePreviewsUpsellProps) {
  return (
    <div
      className={`relative overflow-hidden rounded-button border border-slate-200/80 bg-[radial-gradient(circle_at_top_left,_rgba(96,165,250,0.22),_transparent_34%),radial-gradient(circle_at_88%_20%,_rgba(139,92,246,0.16),_transparent_28%),linear-gradient(135deg,_#f8fbff_0%,_#eef4ff_44%,_#f5f3ff_100%)] px-4 py-4 ${className}`}>
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-8 top-2 h-20 w-20 rounded-full bg-blue/10 blur-2xl" />
        <div className="absolute right-4 top-0 h-16 w-16 rounded-full bg-violet-400/10 blur-2xl" />
        <div className="absolute bottom-0 left-1/3 h-14 w-14 rounded-full bg-cyan-300/10 blur-2xl" />
      </div>
      <div className="relative grid gap-4 sm:grid-cols-[minmax(0,1fr)_130px] sm:items-center">
        <div className="min-w-0">
          <span className="inline-flex rounded-full border border-pink bg-pink/15 px-2 py-0.5 text-[11px] font-semibold leading-4 text-pink-dark">
            New
          </span>
          <p className="mt-3 text-base font-medium leading-6 text-slate-900">
            Test your template across email clients before you send with "Live
            Previews".
          </p>
          <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-2 text-sm">
            <button
              type="button"
              onClick={onTryNow}
              className="font-medium text-blue underline decoration-blue/40 underline-offset-2 transition hover:text-blue hover:decoration-blue">
              Try it now
            </button>
            {dismissible && onDismiss ? (
              <button
                type="button"
                onClick={onDismiss}
                className="font-medium text-sm text-slate-500 transition-colors hover:text-slate-800">
                Maybe later
              </button>
            ) : null}
          </div>
        </div>
        <div className="relative hidden sm:block">
          <img
            src={previews1xSrc}
            srcSet={`${previews1xSrc} 1x, ${previews2xSrc} 2x, ${previews3xSrc} 3x`}
            sizes="130px"
            alt="Live preview renders across multiple email clients."
            className="block h-auto w-full object-contain drop-shadow-[0_16px_30px_rgba(15,23,42,0.18)]"
          />
        </div>
      </div>
    </div>
  );
}

export default LivePreviewsUpsell;
